/**
 * Gedeelde ruimte-state: netto m² + snijverlies (localStorage) + cart line-properties.
 * Keys: uf_orient_area_m2, uf_orient_waste_mode, uf_orient_waste_pct
 * Props: Oppervlakte, Snijverlies, Totaal m²
 */
(function (w) {
  'use strict';

  var KEYS = {
    area: 'uf_orient_area_m2',
    mode: 'uf_orient_waste_mode',
    pct: 'uf_orient_waste_pct'
  };

  var PROP = {
    area: 'Oppervlakte',
    waste: 'Snijverlies',
    total: 'Totaal m²'
  };

  var PROP_KEYS = [PROP.area, PROP.waste, PROP.total];

  function parseNum(raw) {
    var n = parseFloat(String(raw == null ? '' : raw).replace(',', '.'));
    return isFinite(n) ? n : NaN;
  }

  function formatM2(n, digits) {
    var d = digits == null ? 2 : digits;
    var v = Math.round(Number(n) * Math.pow(10, d)) / Math.pow(10, d);
    if (!isFinite(v)) return '';
    return String(v).replace('.', ',');
  }

  function formatPct(n) {
    var v = Number(n);
    if (!isFinite(v)) return '';
    var s = String(Math.round(v * 100) / 100);
    return s.indexOf('.') !== -1 ? s.replace('.', ',') : s;
  }

  function modeLabel(mode) {
    if (mode === 'pro') return 'professioneel';
    if (mode === 'custom') return 'aangepast';
    return 'zelf leggen';
  }

  function normalizeMode(mode) {
    var m = String(mode || '').toLowerCase();
    if (m === 'pro' || m === 'diy' || m === 'custom') return m;
    return '';
  }

  function persist(opts) {
    opts = opts || {};
    try {
      var area = parseNum(opts.areaM2);
      if (isFinite(area) && area > 0) {
        localStorage.setItem(KEYS.area, String(Math.round(area * 100) / 100));
      } else if (opts.clearArea) {
        localStorage.removeItem(KEYS.area);
      }

      var mode = normalizeMode(opts.wasteMode);
      if (mode) localStorage.setItem(KEYS.mode, mode);

      var pct = parseNum(opts.wastePct);
      if (isFinite(pct) && pct >= 0) {
        localStorage.setItem(KEYS.pct, String(Math.round(pct * 100) / 100));
      }
    } catch (e) {
      /* ignore */
    }
  }

  function load() {
    var out = { areaM2: null, wasteMode: '', wastePct: null };
    try {
      var area = parseNum(localStorage.getItem(KEYS.area));
      if (isFinite(area) && area > 0) out.areaM2 = Math.round(area * 100) / 100;
      out.wasteMode = normalizeMode(localStorage.getItem(KEYS.mode));
      var pct = parseNum(localStorage.getItem(KEYS.pct));
      if (isFinite(pct) && pct >= 0) out.wastePct = Math.round(pct * 100) / 100;
    } catch (e) {
      /* ignore */
    }
    return out;
  }

  function buildProperties(opts) {
    opts = opts || {};
    var area = parseNum(opts.areaM2);
    var pct = parseNum(opts.wastePct);
    var total = parseNum(opts.totalM2);
    if (!isFinite(total) && isFinite(area) && isFinite(pct)) {
      total = area * (1 + pct / 100);
    }
    if (!(isFinite(area) && area > 0)) return null;
    var mode = normalizeMode(opts.wasteMode) || 'diy';
    var props = {};
    props[PROP.area] = formatM2(area) + ' m\u00b2';
    if (isFinite(pct) && pct >= 0) {
      props[PROP.waste] = formatPct(pct) + '% (' + modeLabel(mode) + ')';
    }
    if (isFinite(total) && total > 0) {
      props[PROP.total] = formatM2(total) + ' m\u00b2';
    }
    return props;
  }

  function readProp(props, key) {
    if (!props) return '';
    if (props[key] != null && props[key] !== '') return String(props[key]);
    return '';
  }

  function isRoomPropKey(key) {
    return PROP_KEYS.indexOf(String(key || '')) !== -1;
  }

  function cartMetaFromProperties(props) {
    var area = readProp(props, PROP.area);
    var waste = readProp(props, PROP.waste);
    var total = readProp(props, PROP.total);
    var roomMeta = '';
    if (area && waste && total) {
      roomMeta = 'Nodig: ' + area + ' + ' + waste + ' \u2192 ' + total;
    } else if (area && total) {
      roomMeta = 'Nodig: ' + area + ' \u2192 ' + total;
    } else if (area) {
      roomMeta = 'Oppervlakte: ' + area;
    }
    var displayProps = {};
    if (props) {
      Object.keys(props).forEach(function (k) {
        if (isRoomPropKey(k)) return;
        if (props[k] == null || props[k] === '') return;
        displayProps[k] = props[k];
      });
    }
    return {
      hasRoom: !!(area || waste || total),
      roomMeta: roomMeta,
      displayProperties: displayProps
    };
  }

  function packWord(n) {
    return Math.abs(Number(n) - 1) < 0.001 ? 'pak' : 'pakken';
  }

  function formatLineM2InPacks(m2Text) {
    var t = String(m2Text || '').trim();
    if (!t) return '';
    if (/in pakken$/i.test(t)) return t;
    if (/m\u00b2$/i.test(t) || /m2$/i.test(t)) return t + ' in pakken';
    return t + ' m\u00b2 in pakken';
  }

  w.UfRoomState = {
    KEYS: KEYS,
    PROP: PROP,
    PROP_KEYS: PROP_KEYS,
    parseNum: parseNum,
    formatM2: formatM2,
    formatPct: formatPct,
    modeLabel: modeLabel,
    persist: persist,
    load: load,
    buildProperties: buildProperties,
    cartMetaFromProperties: cartMetaFromProperties,
    isRoomPropKey: isRoomPropKey,
    packWord: packWord,
    formatLineM2InPacks: formatLineM2InPacks
  };
})(window);
